module.exports = __webpack_public_path__ + "Server-HasWarnings.TentaclePassive.16672ceeb7ae8450d22ca7ebeb258a06.hashedasset.svg";